import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/certificateType01/registerUseCase';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as getEmailAndPhoneActions } from '@/domain/useCases/getEmailAndPhoneUseCase';
import GraduatedCertificateRegisterView from './GraduatedCertificateRegisterView';
import routes from '@/presentation/components/Routes/routingMap';
import useProfile from '@/presentation/hooks/useProfile';

const GraduatedCertificatedRegisterController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [viewContent, setViewContent] = useState(false);
  const [checkDocument, setCheckDocument] = useState(false);
  const { procedure: procedureInfo } = useSelector(
    (state: any) => state.procedureInformation
  );

  const {
    isLoading: isLoadingRegister,
    requestId: requestIdRegistered,
    isSuccess: isSuccessRegister
  } = useSelector((state: any) => state.registerCertificateType01);
  const student = useProfile();

  const { data: dataEmail } = useSelector(
    (state: any) => state.getEmailAndPhone
  );

  const handlerBackButton = () => {
    history.push('/tramites');
  };

  useEffect(() => {
    dispatch(getEmailAndPhoneActions.getEmailAndPhone());
  }, []);

  const handleRegister = () => {
    dispatch(
      registerActions.registerCertificateOfStudies(
        procedureInfo.id,
        {
          value: '2252',
          label: 'Ciclo Marzo - 2025'
        },
        procedureInfo?.detail?.program || '',
        procedureInfo?.detail?.weightedAverage?.toString() || '',
        procedureInfo?.detail?.hasDebts || null
      )
    );
  };

  useEffect(() => {
    if (isSuccessRegister && requestIdRegistered) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          1040,
          requestIdRegistered
        )
      );

      history.push(
        routes.student.procedures.categories.requests.GraduatedCertificate
          .progress
      );
    }
  }, [isSuccessRegister]);

  return (
    <GraduatedCertificateRegisterView
      onBack={handlerBackButton}
      procedureSelectedInfo={procedureInfo}
      content={{
        viewContent,
        setViewContent
      }}
      check={{
        checkDocument,
        setCheckDocument
      }}
      handleRegister={handleRegister}
      isLoadingRegister={isLoadingRegister}
      dataEmail={dataEmail}
      student={student}
    />
  );
};

export default GraduatedCertificatedRegisterController;
